import {Component, Inject} from '@angular/core';
import {DateAdapter, MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {kanPartnersService} from "../../../services/services/partners";
import {Partner} from "../../../../classes/partner";
import {PartnerType} from "../../../../classes/partnerType";

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

@Component({
    selector: 'kan-partner-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanPartnerDialog {

    public generalDataForm: FormGroup;
    public adressForm: FormGroup;

    public partner: Partner = new Partner();
    public partnerTypes: PartnerType[];
    public selectedPartnerType: PartnerType;
    public isNew: boolean = true;
    public oldEmail: string;

    constructor(private dialogRef: MatDialogRef<kanPartnerDialog>,
                private adapter: DateAdapter<any>,
                private formBuilder: FormBuilder,
                private partnersService: kanPartnersService,
                @Inject(MAT_DIALOG_DATA) private data: any) {
        if (this.data && this.data.partner) {
            this.partner = JSON.parse(JSON.stringify(this.data.partner));
            this.oldEmail = this.partner.email;
            this.isNew = false;
        }
    }

    ngOnInit(): void {

        this.adapter.setLocale('es');

        this.partnersService.getPartnerTypes()
            .then((partnerTypes) => {
                this.partnerTypes = partnerTypes;
                if (this.partner.type) {
                    this.selectedPartnerType = this.partnerTypes.find((partnerType) => {
                        return partnerType.id === this.partner.type.id;
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });

        this.generalDataForm = this.formBuilder.group({
            name: new FormControl(this.partner.name, [Validators.required]),
            type: new FormControl(this.selectedPartnerType, [Validators.required]),
            email: new FormControl(this.partner.email, [Validators.required, Validators.pattern(EMAIL_REGEX)]),
            phone: new FormControl(this.partner.phone),
            contactPerson: new FormControl(this.partner.contactPerson)
        });

        this.adressForm = this.formBuilder.group({
            address: new FormControl(this.partner.address),
            city: new FormControl(this.partner.city),
            cp: new FormControl(this.partner.cp)
        });
    }

    public checkEmail(event: any) {
        if (this.generalDataForm.controls.email.valid && this.partner.email !== this.oldEmail) {
            this.partnersService.isEmailUsed(this.partner.email)
                .then((isUsed) => {
                    this.generalDataForm.controls.email.setErrors(isUsed ? {'used': true} : null);
                });
        }
    }

    public addPartner(event: any) {
        this.partner.partnerTypeId = this.selectedPartnerType.id;
        this.partnersService.addPartner(this.partner)
            .then((data) => {
                this.dialogRef.close('add')
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public updatePartner(event: any) {
        this.partner.partnerTypeId = this.selectedPartnerType.id;
        this.partnersService.updatePartner(this.partner)
            .then((data) => {
                this.dialogRef.close('update')
            })
            .catch((error) => {
                console.log(error);
            });
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/partner-dialog/component.ts